export enum NotificationType {
  Mention = "Mention",
}
